import { GardenConfigContainer } from '@modules/garden-config/containers/garden_config_container';
import { GardenConfig } from '@modules/garden-config/views/garden_config_view';
import { SowingConfig } from '@modules/garden-config/views/sowing_config_view';

export function GardenConfigScreen() {
  return <GardenConfigContainer View={GardenConfig} SowingView={SowingConfig} />;
}
